import angularServiceHelper = require("./angularservicehelper")
import breeze = require("breeze-client");
import coreConstants = require("./core.constants")
import coreSettings = require("./coresettings")

export interface EntitySetDictionary {
    [entitySetName: string]: breeze.Entity[];
}

export class EntityTypeNames {
    public static Person = "Person";
    public static PersonCompetence = "PersonCompetence";
    public static Activity = "Activity";
    public static ManualActivityAdjustment = "ManualActivityAdjustment";

    public static Workplace = "Workplace";
    public static PersonWorkplace = "PersonWorkplace";
    public static WorkGroup = "WorkGroup";
    public static WorkGroupPerson = "WorkGroupPerson";
    public static Authority = "Authority";
    public static CompetenceRequirementCollection = "CompetenceRequirementCollection";
    public static CompetenceRequirement = "CompetenceRequirement";
    public static ActivityType = "ActivityType";
    public static RoleType = "RoleType";
    public static JobType = "JobType";
    public static PersonJob = "PersonJob";
    public static PersonRole = "PersonRole";
    public static CompetenceGroup = "CompetenceGroup";
    public static CompetenceType = "CompetenceType";
    public static ApplicationUser = "ApplicationUser";
    public static CompetenceRequirementActivityType = "CompetenceRequirementActivityType";
    public static CompetenceRequirementCompetenceType = "CompetenceRequirementCompetenceType";
    public static CompetenceRequirementRoleType = "CompetenceRequirementRoleType";
}
    
export interface CacheQueryItem {
    queryId: string;
    entityTypeName: string;
    applyQuery: (query: breeze.EntityQuery) => breeze.EntityQuery;

}

export class EntityCache {

    private _entityCache: EntitySetDictionary;

    constructor(public entityManager: breeze.EntityManager) {
        this._entityCache = {};
    }

    public markForRefresh(entityTypeNames: string[]) {
        for (var i = 0; i < entityTypeNames.length; i++) {
            //this.entityManager.getEntities(entityTypeNames[i]);
            var entities = this.entityManager.getEntities(entityTypeNames[i]);
            entities.forEach(entity => { this.entityManager.detachEntity(entity); });
        }
    }

    public getEntitySetsPromise(entityTypeNames: string[]): ng.IPromise<EntitySetDictionary> {
        var result = angularServiceHelper.Services.$q.defer<EntitySetDictionary>();

        var promises: Promise<breeze.QueryResult>[] = [];
        
        var fetchDataFunc = () => {
            for (var i = 0; i < entityTypeNames.length; i++) {
                if (!this._entityCache[entityTypeNames[i]]) {

                    this._entityCache[entityTypeNames[i]] = this.entityManager.getEntities(entityTypeNames[i]);
                    if (this._entityCache[entityTypeNames[i]].length <= 0) {
                        promises.push(this.getEntityQueryPromise(entityTypeNames[i]));
                    }
                }
            }

            if (promises.length <= 0) {
                result.resolve(this._entityCache);
            } else {
                angularServiceHelper.Services.$q.all(promises)
                    .then(_res => {
                    for (var i = 0; i < entityTypeNames.length; i++) {
                        this._entityCache[entityTypeNames[i]] = this.entityManager.getEntities(entityTypeNames[i]);
                    }

                    result.resolve(this._entityCache)
                }).catch(reason => {
                    result.reject(reason);
                });
            }
        }

        if (this.entityManager.metadataStore.isEmpty()) {
            this.entityManager.fetchMetadata().then(_res => {
                __commonMetadataStore = (<any>this.entityManager).metadataStore;
                fetchDataFunc();
            }).catch(reason => {
                result.reject(reason);
            });
        } else {
            fetchDataFunc();
        };
        return result.promise; 
    }
    
    getMetedata(entityTypeName: string): breeze.EntityType {
        return <breeze.EntityType> this.entityManager.metadataStore.getEntityType(entityTypeName);
    }

    getEntityQueryPromise(entityTypeName: string): Promise<breeze.QueryResult> {
        var metadata = this.getMetedata(entityTypeName);
        var entitySetName = metadata.defaultResourceName;
        var query = new breeze.EntityQuery(entitySetName);
        if (metadata.getProperty("Name")) {
            query = query.orderBy("Name");
        }
        if (metadata.getProperty("Active") && entitySetName == "Persons") {
            query = query.where("Active", "==", true); // Bert filitur á Persons entitetin
        }

        return this.entityManager.executeQuery(query);
    }


    getEntityQueryPromise2(queryItem: CacheQueryItem): Promise<breeze.QueryResult> {
        var metadata = this.getMetedata(queryItem.entityTypeName);
        var entitySetName = metadata.defaultResourceName;
        var query = new breeze.EntityQuery(entitySetName);
        if (queryItem.applyQuery) query = queryItem.applyQuery(query);

        return this.entityManager.executeQuery(query);
    }

    public getEntityQueriesPromise(queries: CacheQueryItem[]): ng.IPromise<EntitySetDictionary> {
        var result = angularServiceHelper.Services.$q.defer<EntitySetDictionary>();

        var fetchDataFunc = () => {
            var promises: Promise<breeze.QueryResult>[] = [];
            for (var i = 0; i < queries.length; i++) promises.push(this.getEntityQueryPromise2(queries[i]));

            if (promises.length <= 0) {
                result.resolve(this._entityCache);
            } else {
                angularServiceHelper.Services.$q.all(promises)
                    .then((res: any) => {
                    var queryResults = <EntitySetDictionary>{};
                    for (var i = 0; i < queries.length; i++) {
                        if (res[i]) {
                            queryResults[queries[i].queryId] = res[i].results;
                        }
                    }

                    result.resolve(queryResults);
                }).catch(reason => {
                    result.reject(reason);
                });
            }
        }

        if (this.entityManager.metadataStore.isEmpty()) {
            
            this.entityManager.fetchMetadata().then(_res => {
                __commonMetadataStore = (<any>this.entityManager).metadataStore;
                fetchDataFunc();
            }).catch(reason => {
                result.reject(reason);
            });
        } else {
            fetchDataFunc();
        };
        return result.promise; 
    }

    getEntity(entityTypeName: string, id: number): breeze.Entity {
        return this.entityManager.getEntityByKey(entityTypeName, id);
    }

    getLocalEntities(entityTypeName: string): breeze.Entity[] {
        return this.entityManager.getEntities(entityTypeName);
    }

    searchActiveByName(entityTypeName: string, searchString: string, maxNrItems: number = 100): breeze.Entity[]{
        var metadata = (<breeze.EntityType>this.entityManager.metadataStore.getEntityType(entityTypeName));
        var entitySetName = metadata.defaultResourceName;

        var query = new breeze.EntityQuery(entitySetName).where("Name", "contains", searchString);

        if (metadata.getProperty("Active") && !coreSettings.applicationSettings.showInactive) query = query.where("Active", "==", true);
        query = query.orderBy("Name")
            .take(maxNrItems);
        return this.entityManager.executeQueryLocally(query);
    }

    searchListByName(sourceItems: breeze.Entity[], searchString: string): breeze.Entity[] {
        var query = breeze.EntityQuery.fromEntities(sourceItems)
            .where("Name", "contains", searchString)
            .orderBy("Name");
        return query.executeLocally();
    }

    public refreshEntities(entities: breeze.Entity): Promise<breeze.QueryResult> {
        var query = breeze.EntityQuery.fromEntities(entities);
        return this.entityManager.executeQuery(query);
    }
}

var __commonMetadataStore = breeze.MetadataStore;

export class CommonEntityManagersClass {

    private _entityManager: breeze.EntityManager;

    public get EntityManager(): breeze.EntityManager {
        this._entityManager = this.ensureManager(this._entityManager);
        return this._entityManager;
    }
    public set EntityManager(value: breeze.EntityManager) {
        this._entityManager = value;
    }

    private ensureManager(value: breeze.EntityManager) {
        if (!value) {
            var options: breeze.EntityManagerOptions = { serviceName: coreConstants.ServiceConfig.oDataUrl };
            if (__commonMetadataStore) (<any>options).metadataStore = __commonMetadataStore;
            value = new breeze.EntityManager(coreConstants.ServiceConfig.oDataUrl);
        }
        return value;
    }
}

export var CommonEntityManagers = new CommonEntityManagersClass();


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/core/entitycache.ts